module.exports = __webpack_public_path__ + "static/media/T12_headboard Finishing_Eco Nabuk_Ivory.05bd4734.png";